import { render, staticRenderFns } from "./TlmContentfulMarkdown.vue?vue&type=template&id=1d1e3743"
import script from "./TlmContentfulMarkdown.vue?vue&type=script&lang=js"
export * from "./TlmContentfulMarkdown.vue?vue&type=script&lang=js"
import style0 from "./TlmContentfulMarkdown.vue?vue&type=style&index=0&id=1d1e3743&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports